import * as Types from '../../graphql.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {};
export type CreateValuationLeadMutationVariables = Types.Exact<{
    lead: Types.ValuationLeadInput;
}>;

export type CreateValuationLeadMutation = { __typename?: 'Mutation' } & {
    createValuationLead: { __typename?: 'ValuationLeadResponse' } & Pick<
        Types.ValuationLeadResponse,
        'uniqueLeadIdentifier'
    >;
};

export const CreateValuationLeadDocument = gql`
    mutation CreateValuationLead($lead: ValuationLeadInput!) {
        createValuationLead(lead: $lead) {
            uniqueLeadIdentifier
        }
    }
`;
export type CreateValuationLeadMutationFn = Apollo.MutationFunction<
    CreateValuationLeadMutation,
    CreateValuationLeadMutationVariables
>;

/**
 * __useCreateValuationLeadMutation__
 *
 * To run a mutation, you first call `useCreateValuationLeadMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateValuationLeadMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createValuationLeadMutation, { data, loading, error }] = useCreateValuationLeadMutation({
 *   variables: {
 *      lead: // value for 'lead'
 *   },
 * });
 */
export function useCreateValuationLeadMutation(
    baseOptions?: Apollo.MutationHookOptions<
        CreateValuationLeadMutation,
        CreateValuationLeadMutationVariables
    >
) {
    const options = { ...defaultOptions, ...baseOptions };
    return Apollo.useMutation<
        CreateValuationLeadMutation,
        CreateValuationLeadMutationVariables
    >(CreateValuationLeadDocument, options);
}
export type CreateValuationLeadMutationHookResult = ReturnType<
    typeof useCreateValuationLeadMutation
>;
export type CreateValuationLeadMutationResult =
    Apollo.MutationResult<CreateValuationLeadMutation>;
export type CreateValuationLeadMutationOptions = Apollo.BaseMutationOptions<
    CreateValuationLeadMutation,
    CreateValuationLeadMutationVariables
>;
